import EuroIcon from "@mui/icons-material/Euro";
import React from "react";

type Props = {
  error?: boolean;
};

export const EuroEndAdornment = ({ error }: Props) => {
  return (
    <EuroIcon color={error ? "error" : "inherit"} sx={{ opacity: !error ? "0.65" : undefined }} />
  );
};
